export const iosInstallUrl = 'https://apps.apple.com/app/id362057947';
export const androidInstallUrl = 'https://play.google.com/store/apps/details?id=com.kakao.talk&hl=ko';



// WEBPACK FOOTER //
// ./src/constants/Urls.js